import React from 'react';
import PropTypes from 'prop-types';
import Image from 'Components/ComponentLibrary/Atoms/Image';


const AdditionalDetailsSectionImage = ({ relationship }) => {
  return (
    <Image src={relationship.link('related').url()} />
  );
};

AdditionalDetailsSectionImage.propTypes = {
  relationship: PropTypes.object.isRequired,
};
AdditionalDetailsSectionImage.defaultProps = {};

export default AdditionalDetailsSectionImage;
